import styled from "styled-components";

export const ChartArea = styled.main`
	background-color: ${props => 'transparent' || props.theme.chartBgColor};
`